import(/* webpackMode: "eager" */ "/tmp/8de59257c360032/app/[locale]/error.tsx");
